import { render, staticRenderFns } from "./OrderSpreadsheetFormatsNew.vue?vue&type=template&id=27c6d69e&"
import script from "./OrderSpreadsheetFormatsNew.vue?vue&type=script&lang=js&"
export * from "./OrderSpreadsheetFormatsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports